const variants = [
  {
    props: { horizontalScroll: true },
    style: {
      overflowX: 'auto',
    },
  },
];

export default variants;
